//import { useEffect, useState } from 'react';
import COLORS from '../../theme/Colors';
import InputAdornment from '@mui/material/InputAdornment';
import { Autocomplete, Grid } from '@mui/material';
import { useQuery } from 'react-query';
import {
  Container,
  ContactContainer,
  MediumContainer,
  Title,
  SubTitle,
  AnalyticsContainer,
  SearchTextInput,
  CenterContainer,
  SearcherContainer,
  StyledDescriptionIcon,
  StyledPersonAddIcon,
  StyledSearchIcon,
  StyledSearchIconForSearcher,
  ContainerSection,
  ContainerImg,
  ContainerContacto,
  TextSuport,
  SubtitleContactanos,
  HomeCenterContent,
  HomeContainer,
  SearcherTitle,
  SearcherSubTitle,
  CardsContainer,
  CardsDivider,
  LogoImage,
  ContainerVideo,
  VideoOverlay
} from './styles/HomeStyles';
import { useHistory } from 'react-router';
import {
  getCarouselImages,
  getHomeImages,
  getHomeMotto,
  getHomeMetricsData
} from '../../api/Home';
import { ContactHome } from './components/contactHome/ContactHome';
import { MediumHeightDivider, Row } from '../../theme/Styles';
import CenterLoading from '../../components/CenterLoading/CenterLoading';
import { SmallHeightDivider } from '../../theme/Styles';
import { getAllServices } from '../../api/ListOfServicesPerCategory';
import { getAlcaldias } from '../../api/Alcaldia';
import InstitutionsCarousel from './components/InstitutionsCarousel/InstitutionsCarousel';
import Logo from '../../assets/images/SecondaryLogoWhite.png'
import { Fragment, useState } from 'react';
import ServiceCard from './components/ServiceCard/ServiceCard';
import Footer from "./components/Footer/Footer";

function Home() {
  const history = useHistory();

  const { data: homeMotto, isLoading: homeMottoIsLoading } = useQuery(['homeMotto'], () => getHomeMotto());
  const { data: homeMetrics, isLoading: homeMetricsIsLoading } = useQuery(['homeMetrics'], () => getHomeMetricsData());
  const { data: homeImages, isLoading: homeImagesIsLoading } = useQuery(['homeImages'], () => getHomeImages());
  const { data: carouselImages, isLoading: carouselImagesIsLoading } = useQuery(['carouselImages'], () => getCarouselImages());
  const { data: listOfServices, isLoading: listOfServicesIsLoading } = useQuery(['listOfServices'], () => getAllServices())
  const { data: alcaldias } = useQuery(['alcaldias'], () => getAlcaldias(), { staleTime: 0, cacheTime: 0 })

  const [showVideoOverlay, setShowVideoOverlay] = useState(true);

  const goToSelectedService = (service) => {
    history.push(`/app/serviceDescription/${service.id}`);
  };

  if (listOfServicesIsLoading || carouselImagesIsLoading || homeImagesIsLoading || homeMottoIsLoading || homeMetricsIsLoading) return <CenterLoading />;

  const servicesForSearcher = (Array.isArray(listOfServices)
    ? listOfServices.reduce((acc, dir) => acc.concat(dir?.services || []), [])
    : []
  ).map((item) => ({
    id: item?.id,
    title: item?.name,
  }))

  const handleShowVideoOverlay = () => {
    setShowVideoOverlay(false);
  }

  const carouselData = carouselImages?.map((item) => item.url) || [];

  return (
    <Container>
      <HomeContainer image={homeImages?.[0]?.url}>
        <HomeCenterContent>
          <Title>VENTANILLA ÚNICA DE INVERSIÓN</Title>
          <SmallHeightDivider />
          <SmallHeightDivider />
          <SearcherContainer>
            <Autocomplete
              options={servicesForSearcher}
              getOptionLabel={(option) => option.title}
              autoHighlight
              freeSolo
              style={{ width: '100%' }}
              onChange={(e, newValue) => {
                goToSelectedService(newValue)
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.defaultMuiPrevented = true;
                }
              }}

              renderInput={(params) =>
                <SearchTextInput
                  {...params}
                  fullWidth
                  placeholder="Buscar por término o nombre del servicio"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    autoComplete: 'new-password',
                    startAdornment: (
                      <InputAdornment position="start" >
                        <StyledSearchIconForSearcher />
                      </InputAdornment>
                    ),
                  }}
                />}
            />
          </SearcherContainer>
        </HomeCenterContent>
        <LogoImage src={Logo} />
      </HomeContainer>

      <MediumContainer style={{ backgroundColor: COLORS.secondary }}>
        <AnalyticsContainer>
          <div>
            <StyledDescriptionIcon />
            <Title>{homeMetrics?.[0]?.content}</Title>
            <SubTitle>{homeMetrics?.[0]?.title}</SubTitle>
          </div>
          <div>
            <StyledPersonAddIcon />
            <Title>{homeMetrics?.[1]?.content}</Title>
            <SubTitle>{homeMetrics?.[1]?.title}</SubTitle>
          </div>
          <div>
            <StyledSearchIcon />
            <Title>{homeMetrics?.[2]?.content}</Title>
            <SubTitle>{homeMetrics?.[2]?.title}</SubTitle>
          </div>
        </AnalyticsContainer>
      </MediumContainer>
      <Container
        style={{
          backgroundColor: '#EEEEEE',
          minHeight: "80vh",
          justifyContent: "center",
        }}
      >

        <CenterContainer >
        <SmallHeightDivider />
          <SearcherTitle>Trámites que ofrece la VUI</SearcherTitle>
          <SearcherSubTitle >
            {homeMotto?.[0]?.content || ''}
          </SearcherSubTitle>
          <div style={{ height: "60px" }} />


          <Grid justifyContent={'center'} container  direction="row"   spacing={3} >
                        
                             
                                  
         { /* <CardsContainer>*/} 
            {
              (Array.isArray(listOfServices) ? listOfServices : []).map((direction, index) => (
                <Grid   sx={{margin:'2px'}} xs={12} sm={6} md={2} xl={2} item direction="column" key={direction.id}>

           
                  <ServiceCard
                    cardNumber={index}
                    title={direction.name}
                    bodyText={direction.description}
                    onRequestPress={() => history.push(`/app/listOfServices/${direction.id}`)}
                  />
                  <CardsDivider />
                  </Grid>
              ))
            }
   
   </Grid>
          <MediumHeightDivider />
        </CenterContainer>

      </Container>

      {alcaldias && alcaldias.length > 0 && (
        <Container
          style={{
            backgroundColor: '#F5F5F5',
            minHeight: "40vh",
            justifyContent: "center",
          }}
        >
          <CenterContainer>
            <SmallHeightDivider />
            <SearcherTitle>Ayuntamientos</SearcherTitle>
            <div style={{ height: "40px" }} />
            <Grid justifyContent={'center'} container direction="row" spacing={3}>
              {alcaldias.map((alcaldia, index) => (
                <Grid sx={{ margin: '2px' }} xs={12} sm={6} md={2} xl={2} item direction="column" key={alcaldia.id}>
                  <ServiceCard
                    cardNumber={index}
                    title={alcaldia.name}
                    bodyText={alcaldia.municipality || alcaldia.description}
                    requestCustomTitle="VER TRÁMITES"
                    onRequestPress={() => history.push(`/app/alcaldias/${alcaldia.institution_id || alcaldia.id}`)}
                  />
                  <CardsDivider />
                </Grid>
              ))}
            </Grid>
            <MediumHeightDivider />
          </CenterContainer>
        </Container>
      )}

      <ContainerVideo>
        {
          showVideoOverlay ?
            <VideoOverlay display={showVideoOverlay ? 'flex' : 'none'} onClick={handleShowVideoOverlay} />
            :
            <iframe
              width='100%'
              style={{ border: 0, height: '100vh' }}
              frameborder="0"
              allow="autoplay"
              encrypted-media
              allowfullscreen
              loading='lazy'
              src={`https://www.youtube.com/embed/NS30pnAaj3w?autoplay=1&loop=1`} />
        }
      </ContainerVideo>
      <SmallHeightDivider />
      <Footer />
      <MediumHeightDivider />
      <InstitutionsCarousel data={carouselData} />
      <SmallHeightDivider />

      {/*   
      <ContainerSection>
        <ContainerImg image={homeImages[1].url}>
          <div
            style={{
              alignItems: 'flex-start',
              position: 'relative',
              bottom: '27%',
            }}
          >
            <Title>Contáctanos:</Title>
            <SubtitleContactanos>Estamos para servirles</SubtitleContactanos>
          </div>
        </ContainerImg>
        <ContainerContacto style={{ padding: '10px' }}>
          <Row style={{ justifyContent: 'flex-start', marginTop: '50px' }}>
            <Row
              style={{
                alignItems: 'center',
                width: '80%',
                alignSelf: 'left',
                margin: '10px',
              }}
            >
              <ContactHome />
            </Row>
          </Row>
        </ContainerContacto>
      </ContainerSection>
      <MediumHeightDivider/>
      <MediumHeightDivider/>
 */}
      {/*  <ContactContainer>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignSelf: 'center',
            width: '100%',
            justifyContent: 'space-evenly',
          }}
        >
          <Grid
            display='flex'
            alignItems='flex-start'
            justifyContent='flex-start'
            container
            direction='row'
            spacing={{ xs: 2, md: 3 }}
          >
            <Grid item xs={12} sm={12} md={6}>

              <TextSuport>
                Puede contactarnos medíante el siguiente teléfono:
                <br />
                <span
                  style={{
                    fontFamily: 'Bold',
                    fontSize: '18px',
                    color: COLORS.secondary,
                    marginBottom: '10px',
                    fontWeight: '600',
                  }}
                >
                  (809) 530-5505
                </span>
                <br />
                O bien puedes escribirnos mediante el siguiente correo:
                <br />
                <span
                  style={{
                    fontFamily: 'Bold',
                    fontSize: '16px',
                    color: COLORS.secondary,
                  }}
                >
                  Contacto@vui.gob.do
                </span>
                <br />
                <br />
                Horario de servicio: De lunes a viernes de 8:30 a.m. a 4:30 p.m.
              </TextSuport>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              display='flex'
              justifyContent='center'
            >
              <TextSuport>
                <span
                  style={{
                    fontFamily: 'Bold',
                    fontSize: '18px',
                    color: COLORS.secondary,
                    alignContent: 'flex-start',
                    marginBottom: '10px',
                    fontWeight: '600',
                  }}
                >
                  Soporte técnico
                  <hr />
                </span>
                <br />
                Para soporte tecnico de la plataforma hemos
                <br />
                habilitado los siguientes medios:
                <br />
                Teléfono:
                <span
                  style={{
                    fontFamily: 'Bold',
                    fontSize: '16px',
                    color: COLORS.secondary,
                    alignContent: 'flex-start',
                  }}
                >
                  +1 (809) 530 5505
                </span>
                <br />
                Whatsapp:
                <span
                  style={{
                    fontFamily: 'Bold',
                    fontSize: '16px',
                    color: COLORS.secondary,
                    alignContent: 'flex-start',
                  }}
                >
                  +1 (809) 530 5505
                </span>
                <br />
                Correo:
                <span
                  style={{
                    fontFamily: 'Bold',
                    fontSize: '16px',
                    color: COLORS.secondary,
                    alignContent: 'flex-start',
                  }}
                >
                  Contacto@vui.gob.do

                </span>
                <br />
              </TextSuport>
            </Grid>
          </Grid>
        </div>
      </ContactContainer> */}
    </Container>
  );
}

export default Home;
